import { useEffect } from "react";
import { Outlet } from "react-router";
import { SidebarProvider } from "../components/shell/SidebarProvider";
import { Sidebar } from "../components/shell/Sidebar";
import { TopBar } from "../components/shell/TopBar";
import { SidebarOverlay } from "../components/shell/SidebarOverlay";
import { ToastViewport } from "../components/ui/Toast";
import { useMediaQuery } from "../hooks/useMediaQuery";
import { useActiveTenantOrNull } from "../auth/AuthProvider";
import { useBranding } from "../branding/BrandingProvider";
import { useBrandingEffects } from "../branding/useBrandingEffects";

function AppShellInner() {
  const isLg = useMediaQuery("(min-width: 1024px)");
  const isMd = useMediaQuery("(min-width: 768px)");
  const { branding } = useBranding();
  const tenantName = useActiveTenantOrNull()?.name ?? null;

  // Apply branding effects
  useBrandingEffects(branding);

  useEffect(() => {
    document.title = tenantName
      ? `Reflex Labs: ${tenantName} Portal`
      : "Reflex Labs Portal";
  }, [tenantName]);

  // Content margin logic:
  // lg+: always ml-[236px] (sidebar always visible at full width)
  // md (768-1023): ml-16 (64px icon rail always visible)
  // <md: ml-0 (sidebar is overlay drawer, content is full-width)
  const marginClass = isLg ? "ml-[236px]" : isMd ? "ml-16" : "ml-0";

  return (
    <div className="flex h-screen flex-col pt-[var(--banner-h)]">
      <Sidebar />
      <SidebarOverlay />
      <div
        className={`${marginClass} flex min-w-0 min-h-0 flex-1 flex-col sidebar-transition`}
      >
        <TopBar />
        <ToastViewport />
        <main
          id="main-content"
          tabIndex={-1}
          className="min-w-0 min-h-0 flex flex-col flex-1 overflow-y-auto"
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export function AppShell() {
  return (
    <SidebarProvider>
      <AppShellInner />
    </SidebarProvider>
  );
}
